import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tBedModel } from '../models/tBedModel';
import { tItemCateModel } from '../models/tItemCateModel';
import { BehaviorSubject } from 'rxjs';



@Injectable({
    providedIn: 'root'
})

export class tItemCateService {

    /*
    private selected_item_itemCateID_Source = new BehaviorSubject('');
    current_selected_item_itemCateID = this.selected_item_itemCateID_Source.asObservable();

    private selected_item_itemCateName_Source = new BehaviorSubject('');
    current_selected_item_itemCateName = this.selected_item_itemCateName_Source.asObservable();

    private selected_item_isStock_Source = new BehaviorSubject('');
    current_selected_item_isStock = this.selected_item_isStock_Source.asObservable();

    private selected_item_isServiceType_Source = new BehaviorSubject('');
    current_selected_item_isServiceType = this.selected_item_isServiceType_Source.asObservable();

    private selected_item_itemCostMethod_Source = new BehaviorSubject(0);
    current_selected_item_itemCostMethod = this.selected_item_itemCostMethod_Source.asObservable();
    */

    private selected_item_itemCateModel_Source = new BehaviorSubject<tItemCateModel>(null);
    current_selected_item_itemCateModel = this.selected_item_itemCateModel_Source.asObservable();

    private selected_pricebook_itemCateModel_Source = new BehaviorSubject<tItemCateModel>(null);
    current_selected_pricebook_itemCateModel = this.selected_pricebook_itemCateModel_Source.asObservable();



    shareSelected(model: tItemCateModel) {
        this.selected_item_itemCateModel_Source.next(model);
    }

    priceBookShareSelected(model: tItemCateModel) {
        this.selected_pricebook_itemCateModel_Source.next(model);
    }

    /*
    // tslint:disable-next-line:max-line-length
    shareSelected(selecteditemCateID: string, selecteditemCateName: string, isStock: string, isServiceType: string, itemCostMethod: number) {
      this.selected_item_itemCateID_Source.next(selecteditemCateID);
      this.selected_item_itemCateName_Source.next(selecteditemCateName);

      this.selected_item_isStock_Source.next(isStock);
      this.selected_item_isServiceType_Source.next(isServiceType);
      this.selected_item_itemCostMethod_Source.next(itemCostMethod);
    }
    */

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/tItemCate';

    getAllData() {
        return this.http.get<tItemCateModel[]>(this.baseurl + this.pathName);
    }

    getItemCateByCondition(shopID: string, inactive: string , isServiceType :string){
        return this.http.get<tItemCateModel[]>(this.baseurl + this.pathName +"/GetItemCateByCondition/"+ shopID+"/"+inactive+"/"+isServiceType);
    }

    getItemCateByConditionShoppingCart(shopID: string, inactive: string , isServiceType :string){
        return this.http.get<tItemCateModel[]>(this.baseurl + this.pathName +"/GetItemCateByConditionShoppingCart/"+ shopID+"/"+inactive+"/"+isServiceType);
    }

    getDataById(itemCateID: string) {
        return this.http.get<tItemCateModel>(this.baseurl + this.pathName + '/' + itemCateID);
        // return this.http.get<tItemCateModel>(this.baseurl + this.pathName + '/' + applyShop + '/' + itemCateID);
    }

    addData(data: tItemCateModel) {
        return this.http.post(this.baseurl + this.pathName, data);
    }

    deleteData(data: tItemCateModel) {
        return this.http.delete(this.baseurl + this.pathName + '/' + data.itemCateID);
    }

    updateData(data: tItemCateModel) {
        //   data.lastModifyLoginName = "2";
        return this.http.put(this.baseurl + this.pathName + '/Formatted/' + data.itemCateID, data);
    }
}